// Généré par scripts/generate-flipt-types.js — NE PAS ÉDITER. Relancer : yarn flipt:types
export const FLAGS = {
  BOSupply: 'BO-Supply',
  CAForecasting: 'CA-forecasting',
  absenceShift: 'absence-shift',
  adonisQueueInactivateCollaborator: 'adonis-queue-inactivate-collaborator',
  autoClosePreauthOnValidatedCart: 'auto-close-preauth-on-validated-cart',
  automatedInventory: 'automated-inventory',
  cardVerification: 'card-verification',
  collabListViewAndImport: 'collab-list-view-and-import',
  comptaExportPanier: 'compta-export-panier',
  creneauEndsMidnight: 'creneau-ends-midnight',
  dashboardRh: 'dashboard-rh',
  dashboardRhFraisDePerso: 'dashboard-rh-frais-de-perso',
  dashboardRhModalCouverturePlanning: 'dashboard-rh-modal-couverture-planning',
  dashboardRhModalEffectifTotal: 'dashboard-rh-modal-effectif-total',
  dashboardRhModalFpCa: 'dashboard-rh-modal-fp-ca',
  deletePastWorkShift: 'delete-past-work-shift',
  exportFicheCollab: 'export-fiche-collab',
  featureFlags: 'feature-flags',
  formationHourToDefaultStore: 'formation-hour-to-default-store',
  hrExportAttendanceMultiStore: 'hr-export-attendance-multi-store',
  hrExportPlanningMultiStore: 'hr-export-planning-multi-store',
  permissionApiKey: 'permission-api-key',
  permissionV2: 'permission-v2',
  permissionV2Administration: 'permission-v2-administration',
  phoneAuth: 'phone-auth',
  planningRemainingHoursMenu: 'planning-remaining-hours-menu',
  planningShiftCreationUpToFourStores: 'planning-shift-creation-up-to-four-stores',
  planningWidgetsAddingPaidTransport: 'planning-widgets-adding-paid-transport',
  projectTracking: 'project-tracking',
  rhPersonnelDiscountLinkToAgroDigital: 'rh-personnel-discount-link-to-agro-digital',
  rhPointageDisplayPluriBoutique: 'rh-pointage-display-pluri-boutique',
  rhPointageExportV2: 'rh-pointage-export-v2',
  visioReviews: 'visio-reviews',
} as const

export type FlagKey = (typeof FLAGS)[keyof typeof FLAGS]

export interface FliptVariants {
  'BO-Supply': never // flag booléen
  'CA-forecasting': never // flag booléen
  'absence-shift': never // flag booléen
  'adonis-queue-inactivate-collaborator': never // flag booléen
  'auto-close-preauth-on-validated-cart': never // flag booléen
  'automated-inventory': never // flag booléen
  'card-verification': never // flag booléen
  'collab-list-view-and-import': never // flag booléen
  'compta-export-panier': never // flag booléen
  'creneau-ends-midnight': never // flag booléen
  'dashboard-rh': never // flag booléen
  'dashboard-rh-frais-de-perso': never // flag booléen
  'dashboard-rh-modal-couverture-planning': never // flag booléen
  'dashboard-rh-modal-effectif-total': never // flag booléen
  'dashboard-rh-modal-fp-ca': never // flag booléen
  'delete-past-work-shift': never // flag booléen
  'export-fiche-collab': never // flag booléen
  'feature-flags': never // flag booléen
  'formation-hour-to-default-store': never // flag booléen
  'hr-export-attendance-multi-store': never // flag booléen
  'hr-export-planning-multi-store': never // flag booléen
  'permission-api-key': never // flag booléen
  'permission-v2': never // flag booléen
  'permission-v2-administration': never // flag booléen
  'phone-auth': never // flag booléen
  'planning-remaining-hours-menu': never // flag booléen
  'planning-shift-creation-up-to-four-stores': never // flag booléen
  'planning-widgets-adding-paid-transport': never // flag booléen
  'project-tracking': never // flag booléen
  'rh-personnel-discount-link-to-agro-digital': never // flag booléen
  'rh-pointage-display-pluri-boutique': never // flag booléen
  'rh-pointage-export-v2': never // flag booléen
  'visio-reviews': never // flag booléen
}
